import React from "react";
import PaginationModified from "../../../data/PaginationModified";
import { convertStraight, convertThenFormat, currentDateOfTheMonth } from "../../common-data/Converts";
import moment from "moment";

const AgentReportMobileCard = ({
  tableData,
  type,
  setClickValues,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {type === "fdsop" ? (
        <>
          {tableData?.length > 0 &&
            tableData.map((row, index) => {
              return (
                <div className="log-card" key={index}>
                  <div className="all-info-agent">
                    <div className="label-value-agent flexCol">
                      <span className="label">FD Info</span>
                      <span className="value">
                        {row?.name || "NA"}
                        <br />
                        <small className="lowercase">
                          {row?.mobile || ""}
                          <br />
                          {row?.email || ""}
                        </small>
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">this month total unpaid </span>
                      <span className="value">
                        {row?.this_month_total_unpaid
                          ? row?.this_month_total_unpaid
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">
                        this month unpaid added to lead
                      </span>
                      <span className="value">
                        {row?.this_month_unpaid_added_to_lead
                          ? row?.this_month_unpaid_added_to_lead
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">
                        this month unpaid today follow up ({convertStraight(currentDateOfTheMonth)})
                      </span>
                      <span className="value">
                        {row?.this_month_unpaid_today_followup
                          ? row?.this_month_unpaid_today_followup
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">sixty days total unpaid</span>
                      <span className="value">
                        {row?.sixty_days_total_unpaid
                          ? row?.sixty_days_total_unpaid
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">
                        sixty days unpaid added to lead
                      </span>
                      <span className="value">
                        {row?.sixty_days_unpaid_added_to_lead
                          ? row?.sixty_days_unpaid_added_to_lead
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">
                        sixty days unpaid not added to lead
                      </span>
                      <span className="value">
                        {row?.sixty_days_unpaid_not_added_to_lead
                          ? row?.sixty_days_unpaid_not_added_to_lead
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">
                        sixty days unpaid today follow up ({convertStraight(currentDateOfTheMonth)})
                      </span>
                      <span className="value">
                        {row?.sixty_days_unpaid_today_followup
                          ? row?.sixty_days_unpaid_today_followup
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">
                        this month missed interested follow up
                      </span>
                      <span className="value">
                        {row?.this_month_missed_interested_followup
                          ? row?.this_month_missed_interested_followup
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">today follow up added ({convertStraight(currentDateOfTheMonth)})</span>
                      <span className="value">
                        {row?.today_followup_added
                          ? row?.today_followup_added
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">advance renewel this month</span>
                      <span className="value">
                        {row?.advancerenew_this_month
                          ? row?.advancerenew_this_month
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">
                        advance renewel today follow up ({convertStraight(currentDateOfTheMonth)})
                      </span>
                      <span className="value">
                        {row?.advancerenew_today_followup
                          ? row?.advancerenew_today_followup
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">expiry today ({convertStraight(currentDateOfTheMonth)})</span>
                      <span className="value">
                        {row?.expt_today ? row?.expt_today : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">expiry today follow up ({convertStraight(currentDateOfTheMonth)})</span>
                      <span className="value">
                        {row?.expt_today_followup
                          ? row?.expt_today_followup
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">raw lead assigned today ({convertStraight(currentDateOfTheMonth)})</span>
                      <span className="value">
                        {row?.rawlead_assigned_today
                          ? row?.rawlead_assigned_today
                          : "NA"}{" "}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">
                        raw lead assigned today follow up ({convertStraight(currentDateOfTheMonth)})
                      </span>
                      <span className="value">
                        {row?.rawlead_assigned_today_followup
                          ? row?.rawlead_assigned_today_followup
                          : "NA"}{" "}
                      </span>
                    </div>
                    <div className="label-value-agent flexCol">
                      <span className="label">sales completed today ({convertStraight(currentDateOfTheMonth)})</span>
                      <span className="value">
                        {row?.sales_completed_today
                          ? `₹${convertThenFormat(row?.sales_completed_today)}`
                          : "NA"}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
        </>
      ) : type === "agentsop" ? (
        <>
          {tableData?.length > 0 &&
            tableData.map((row, index) => {
              return (
                <div className="log-card" key={index}>
                  <div className="all-info-agent">
                    <div className="label-value-agent">
                      <span className="label">gym name</span>
                      <span
                        className="value link"
                        style={{ color: "blue", textDecoration: "underline" }}
                        onClick={() => {
                          setClickValues({
                            isModOpen: true,
                            rowData: row,
                            cardName: "fd-task-SOP",
                          });
                        }}
                      >
                        {row?.gym_name ? row?.gym_name : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">this month total unpaid </span>
                      <span className="value">
                        {row?.this_month_total_unpaid
                          ? row?.this_month_total_unpaid
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">
                        this month unpaid added to lead
                      </span>
                      <span className="value">
                        {row?.this_month_unpaid_added_to_lead
                          ? row?.this_month_unpaid_added_to_lead
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">
                        this month unpaid today follow up
                      </span>
                      <span className="value">
                        {row?.this_month_unpaid_today_followup
                          ? row?.this_month_unpaid_today_followup
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">sixty days total unpaid</span>
                      <span className="value">
                        {row?.sixty_days_total_unpaid
                          ? row?.sixty_days_total_unpaid
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">
                        sixty days unpaid added to lead
                      </span>
                      <span className="value">
                        {row?.sixty_days_unpaid_added_to_lead
                          ? row?.sixty_days_unpaid_added_to_lead
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">
                        sixty days unpaid not added to lead
                      </span>
                      <span className="value">
                        {row?.sixty_days_unpaid_not_added_to_lead
                          ? row?.sixty_days_unpaid_not_added_to_lead
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">
                        sixty days unpaid today follow up
                      </span>
                      <span className="value">
                        {row?.sixty_days_unpaid_today_followup
                          ? row?.sixty_days_unpaid_today_followup
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">
                        this month missed interested follow up
                      </span>
                      <span className="value">
                        {row?.this_month_missed_interested_followup
                          ? row?.this_month_missed_interested_followup
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">today follow up added</span>
                      <span className="value">
                        {row?.today_followup_added
                          ? row?.today_followup_added
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">advance renewel this month</span>
                      <span className="value">
                        {row?.advancerenew_this_month
                          ? row?.advancerenew_this_month
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">
                        advance renewel today follow up
                      </span>
                      <span className="value">
                        {row?.advancerenew_today_followup
                          ? row?.advancerenew_today_followup
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">expiry today</span>
                      <span className="value">
                        {row?.expt_today ? row?.expt_today : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">expiry today follow up</span>
                      <span className="value">
                        {row?.expt_today_followup
                          ? row?.expt_today_followup
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">raw lead assigned today</span>
                      <span className="value">
                        {row?.rawlead_assigned_today
                          ? row?.rawlead_assigned_today
                          : "NA"}{" "}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">
                        raw lead assigned today follow up
                      </span>
                      <span className="value">
                        {row?.rawlead_assigned_today_followup
                          ? row?.rawlead_assigned_today_followup
                          : "NA"}{" "}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span className="label">total receptionist</span>
                      <span className="value">
                        {row?.total_receptionist ? row?.total_receptionist : 0}
                      </span>
                    </div>{" "}
                    <div className="label-value-agent">
                      <span className="label">sales completed today</span>
                      <span className="value">
                        {row?.sales_completed_today
                          ? `₹${convertThenFormat(row?.sales_completed_today)}`
                          : "NA"}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
        </>
      ) : type === "agentWise" ? (
        <>
          {tableData?.length > 0 &&
            tableData.map((row, index) => {
              return (
                <div className="log-card" key={index}>
                  <div className="all-info-top-agentData">
                    <div className="agent-card-top-data">
                      <h5 className="lead-name">
                        {row?.sub_added_by_name || "NA"}
                      </h5>
                      <p className="number">
                        {row?.sub_added_by_mobile || "NA"}
                      </p>
                      {row?.sub_added_by_email ? (
                        <span className="value email semi-bold">
                          {row?.sub_added_by_email || "NA"}
                        </span>
                      ) : null}
                    </div>
                    <p className="gym_name-agent">{row?.gym_name}</p>
                  </div>

                  <div className="all-info-agent">
                    <div className="label-value-agent">
                      <span>New Recurring Subscription</span>
                      <span>
                        {row?.new_subscription
                          ? `₹${convertThenFormat(row?.new_subscription)}`
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span>renewal</span>
                      <span>
                        {row?.non_recurring_renewal
                          ? `₹${convertThenFormat(row?.non_recurring_renewal)}`
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span>unpaid</span>
                      <span>
                        {row?.non_recurring_unpaid
                          ? `₹${convertThenFormat(row?.non_recurring_unpaid)}`
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span>non recurring other sources</span>
                      <span>
                        {row?.non_recurring_other_sources
                          ? `₹${convertThenFormat(
                              row?.non_recurring_other_sources
                            )}`
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span>New non recurring</span>
                      <span>
                        {row?.membership
                          ? `₹${convertThenFormat(row?.membership)}`
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span>PT</span>
                      <span>
                        {row?.addon_pt
                          ? `₹${convertThenFormat(row?.addon_pt)}`
                          : "NA"}
                      </span>
                    </div>
                    <div className="label-value-agent">
                      <span>Total</span>
                      <span>
                        {row?.total
                          ? `₹${convertThenFormat(row?.total)}`
                          : "NA"}
                      </span>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              );
            })}
        </>
      ) : (
        <>
          <>
            {tableData?.length > 0 &&
              tableData.map((row, index) => {
                return (
                  <div className="log-card" key={index}>
                    <div className="all-info-agent">
                      <div className="label-value-agent">
                        <span className="label">Date</span>
                        <span className="value">
                          {row?.date
                            ? moment(row.date).format("DD-MM-YYYY")
                            : "NA"}
                        </span>
                      </div>
                      <div className="label-value-agent">
                        <span className="label">
                          New Recurring Subscription
                        </span>
                        <span className="value">
                          {row?.new_subscription
                            ? `₹${convertThenFormat(row?.new_subscription)}`
                            : "NA"}
                        </span>
                      </div>
                      <div className="label-value-agent">
                        <span className="label">renewal</span>
                        <span className="value">
                          {row?.non_recurring_renewal
                            ? `₹${convertThenFormat(
                                row?.non_recurring_renewal
                              )}`
                            : "NA"}
                        </span>
                      </div>
                      <div className="label-value-agent">
                        <span className="label">unpaid</span>
                        <span className="value">
                          {row?.non_recurring_unpaid
                            ? `₹${convertThenFormat(row?.non_recurring_unpaid)}`
                            : "NA"}
                        </span>
                      </div>
                      <div className="label-value-agent">
                        <span className="label">
                          non recurring other sources
                        </span>
                        <span className="value">
                          {row?.non_recurring_other_sources
                            ? `₹${convertThenFormat(
                                row?.non_recurring_other_sources
                              )}`
                            : "NA"}
                        </span>
                      </div>
                      <div className="label-value-agent">
                        <span className="label">New non recurring</span>
                        <span className="value">
                          {row?.membership
                            ? `₹${convertThenFormat(row?.membership)}`
                            : "NA"}
                        </span>
                      </div>

                      <div className="label-value-agent">
                        <span className="label">PT</span>
                        <span className="value">
                          {row?.addon_pt
                            ? `₹${convertThenFormat(row?.addon_pt)}`
                            : "NA"}
                        </span>
                      </div>
                      <div className="label-value-agent">
                        <span className="label">Total</span>
                        <span className="value">
                          {row?.total
                            ? `₹${convertThenFormat(row?.total)}`
                            : "NA"}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
          </>
        </>
      )}

      {type !== "agentsop" && (
        <div className="lead-logs-card-pagination">
          <PaginationModified
            isPage={isPage}
            onChangePage={setIsPage}
            pagination={getPagination()}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        </div>
      )}
    </div>
  );
};

export default AgentReportMobileCard;
